import * as enums from "enumerations";

const version: string = "v1";
const statuses = enums.api;

const API = {
   version,
   statuses,
};

export default API;
